module.exports = __webpack_public_path__ + "fonts/turtle-with-squaber-icon.svg";